// extracted by mini-css-extract-plugin
export var infoRow = "_tn-2";
export var labelContainer = "_tn-0";
export var rightInfo = "_tn-1";